import { render, staticRenderFns } from "./FindPasswordSuccess.vue?vue&type=template&id=6b9d7bca"
import script from "./FindPasswordSuccess.vue?vue&type=script&lang=js"
export * from "./FindPasswordSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports